// Vendors
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import i18n from '../../i18n';

// Actions
import { switchLanguage } from '../../reducers/language/languageActions';

// Components
import { Dropdown } from '..';

// Texkit Components
import { Icon } from 'texkit/dist/components/Icon/Icon';

// Styles
import './language-switcher.scss';

class LanguageSwitcher extends Component {
  constructor(props) {
    super(props);
    i18n.changeLanguage(props.selected);
  }

  handleLanguageSelect(language) {
    i18n.changeLanguage(language);
    this.props.switchLanguage(language);
  }

  get languageValue() {
    const { options, selected } = this.props;
    const selectedLanguage = options.find(
      language => language.code === selected
    );
    return selectedLanguage ? selectedLanguage.value : options[0].value;
  }

  render() {
    const { options, dropdownProps } = this.props;
    const items = options.map(option => {
      const optionClassNames = classnames({
        'language-switcher-dropdown-item': true,
        isSelected: this.languageValue === option.value,
      });
      option.onClick = () => this.handleLanguageSelect(option.code);
      option.className = optionClassNames;
      return option;
    });

    return (
      <Dropdown
        {...dropdownProps}
        id="language-switcher"
        className="language-switcher"
        showCheck={true}
        toggleComponent={({ ...props }) => (
          <button {...props} className="language-switcher-toggle" type="button">
            {this.languageValue} <Icon name="chevron-down" />
          </button>
        )}
        items={items}
      />
    );
  }
}

const mapStateToProps = ({
  language: { selected, options, isDropdownOpen },
}) => ({
  selected,
  options,
  isDropdownOpen,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ switchLanguage }, dispatch);

LanguageSwitcher.propTypes = {
  selected: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  switchLanguage: PropTypes.func.isRequired,
  dropdownProps: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSwitcher);
